import { FilterCollection } from '../../constants';
import type { FilterDrawerState, ReadonlySearchParams } from '../../types';
import { isFilterDrawerItemParamId } from '../isFilterDrawerItemParamId/isFilterDrawerItemParamId';

export const getFilterCount = ({
	searchParams,
	filter
}: {
	searchParams: ReadonlySearchParams;
	filter: FilterDrawerState;
}) => {
	return Array.from(searchParams)
		.map(([key]) => key)
		.filter((key) => {
			return isFilterDrawerItemParamId({ filter, key });
		})
		.reduce((prev, key) => {
			const item = searchParams.get(key)?.split(',');

			if (
				filter[key] &&
				filter[key].filterCollection ===
					FilterCollection.Filter_Slider /* filter slider stores values in an array but should only increment the count by 1 */
			) {
				return prev + 1;
			}

			if (Array.isArray(item)) {
				return prev + item.length;
			}

			return prev + 1;
		}, 0);
};
